import { render, staticRenderFns } from "./SupervisionReview.vue?vue&type=template&id=3d57172a"
import script from "./SupervisionReview.vue?vue&type=script&lang=js"
export * from "./SupervisionReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports